import {
    Checkbox,
    Hidden,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
} from '@material-ui/core';
import React from 'react';
import OutputDate from './OutputDate';

function retiradoPor(produtos, pedido) {
    return (
        produtos.find((produto) => produto.pedido === pedido)
            ?.retiradoPor?.trim() || 'Não informado'
    );
}

const Selos = ({
    value,
    onSelecionar,
    usuario,
    btnRadio,
    produtos,
    cartela,
}) => {
    const [selected, setSelected] = React.useState([]);
    const find = (id) => value.find((e) => e.id === id);
    const isSelected = (id) => !!selected.find((e) => e.id === id);
    const onSelectChange = (id) => (e, checked) => {
        if (checked) setSelected([...selected, find(id)]);
        else setSelected(selected.filter((e) => e.id !== id));
    };

    React.useEffect(() => {
        onSelecionar(selected);
    }, [selected, onSelecionar]);

    const total = selected.reduce(
        (total, { quantidade, listaPrecoItemDerivacaoProdutoQuantidade }) =>
            total + quantidade * listaPrecoItemDerivacaoProdutoQuantidade,
        0,
    );

    function existeRetirada2() {
        if (value.length === 0) return false;
        const data = value.some((dt) => {
            if (!!dt?.dataRetirada) return false;
            return true;
        });
        return data;
    }

    return value.length === 0 ? (
        <Typography variant="overline">Nenhum selo disponível</Typography>
    ) : btnRadio !== 2 ? (
        <TableContainer style={{ paddingBottom: '10px' }}>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell padding="checkbox">#</TableCell>
                        <Hidden smDown>
                            <TableCell>Produto</TableCell>
                            <TableCell>Quantidade</TableCell>
                            <TableCell>Campanha</TableCell>
                            <TableCell>Edições</TableCell>
                            <TableCell>Total de Selos</TableCell>
                            <TableCell>Pedido</TableCell>
                            <TableCell>Data da Compra</TableCell>
                        </Hidden>
                        <Hidden mdUp>
                            <TableCell>Produto</TableCell>
                            <TableCell>Qt</TableCell>
                        </Hidden>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {value.map(
                        ({
                            id,
                            pedido,
                            podeRetirar,
                            dataPedido,
                            dataRetirada,
                            quantidade,
                            listaPrecoItemDerivacaoProdutoQuantidade,
                            nomeItem,
                            listaPrecoItemNomeKit,
                            // selos,
                        }) => (
                            <TableRow key={id}>
                                <TableCell>
                                    {
                                        <Checkbox
                                            checked={
                                                !!dataRetirada || isSelected(id)
                                            }
                                            onChange={onSelectChange(id)}
                                            disabled={!podeRetirar}
                                        />
                                    }
                                </TableCell>
                                <Hidden smDown>
                                    <TableCell>
                                        <div>{nomeItem}</div>
                                        {dataRetirada && (
                                            <Typography variant="caption">
                                                RETIRADO:{' '}
                                                <OutputDate
                                                    value={dataRetirada}
                                                />
                                                <br />
                                                POR:{' '}
                                                {retiradoPor(
                                                    produtos,
                                                    pedido,
                                                )}
                                            </Typography>
                                        )}
                                    </TableCell>
                                    <TableCell>{quantidade}</TableCell>
                                    <TableCell>
                                        {listaPrecoItemNomeKit}
                                    </TableCell>
                                    <TableCell>
                                        {
                                            listaPrecoItemDerivacaoProdutoQuantidade
                                        }
                                    </TableCell>
                                    <TableCell>
                                        {quantidade *
                                            listaPrecoItemDerivacaoProdutoQuantidade}
                                    </TableCell>
                                    <TableCell>{pedido}</TableCell>
                                    <TableCell>
                                        <OutputDate value={dataPedido} />
                                    </TableCell>
                                </Hidden>
                                <Hidden mdUp>
                                    <TableCell>
                                        <div>
                                            {listaPrecoItemNomeKit || nomeItem}
                                        </div>
                                        {dataRetirada && (
                                            <Typography variant="caption">
                                                RETIRADO:{' '}
                                                <OutputDate
                                                    value={dataRetirada}
                                                />
                                                <br />
                                                POR:{' '}
                                                {retiradoPor(
                                                    produtos,
                                                    pedido,
                                                )}
                                            </Typography>
                                        )}
                                    </TableCell>
                                    <TableCell>
                                        {quantidade *
                                            listaPrecoItemDerivacaoProdutoQuantidade}
                                    </TableCell>
                                </Hidden>
                            </TableRow>
                        ),
                    )}
                    <TableRow>
                        <Hidden smDown>
                            <TableCell colSpan="7">TOTAL À RETIRAR</TableCell>
                        </Hidden>
                        <Hidden mdUp>
                            <TableCell colSpan="2">TOTAL À RETIRAR</TableCell>
                        </Hidden>
                        <TableCell
                            style={{ fontSize: '1.5em', fontWeight: 800 }}
                        >
                            {total}
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>
    ) : (
        <>
            {!existeRetirada2() ? (
                <Typography variant="overline">
                    Nenhum selo disponível
                </Typography>
            ) : (
                <>
                    <TableContainer style={{ paddingBottom: '10px' }}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell padding="checkbox">#</TableCell>
                                    <Hidden smDown>
                                        <TableCell>Produto</TableCell>
                                        <TableCell>Quantidade</TableCell>
                                        <TableCell>Campanha</TableCell>
                                        <TableCell>Edições</TableCell>
                                        <TableCell>Total de Selos</TableCell>
                                        <TableCell>Pedido</TableCell>
                                        <TableCell>Data da Compra</TableCell>
                                    </Hidden>
                                    <Hidden mdUp>
                                        <TableCell>Produto</TableCell>
                                        <TableCell>Qt</TableCell>
                                    </Hidden>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {value.map(
                                    ({
                                        id,
                                        pedido,
                                        podeRetirar,
                                        dataPedido,
                                        dataRetirada,
                                        quantidade,
                                        listaPrecoItemDerivacaoProdutoQuantidade,
                                        nomeItem,
                                        listaPrecoItemNomeKit,
                                        // selos,
                                    }) => (
                                        <TableRow key={id}>
                                            <TableCell>
                                                {
                                                    <Checkbox
                                                        checked={
                                                            !!dataRetirada ||
                                                            isSelected(id)
                                                        }
                                                        onChange={onSelectChange(
                                                            id,
                                                        )}
                                                        disabled={!podeRetirar}
                                                    />
                                                }
                                            </TableCell>
                                            <Hidden smDown>
                                                <TableCell>
                                                    <div>{nomeItem}</div>
                                                    {dataRetirada && (
                                                        <Typography variant="caption">
                                                            RETIRADO:{' '}
                                                            <OutputDate
                                                                value={
                                                                    dataRetirada
                                                                }
                                                            />
                                                            <br />
                                                            POR:{' '}
                                                            {retiradoPor(
                                                                produtos,
                                                                pedido,
                                                            )}
                                                        </Typography>
                                                    )}
                                                </TableCell>
                                                <TableCell>
                                                    {quantidade}
                                                </TableCell>
                                                <TableCell>
                                                    {listaPrecoItemNomeKit}
                                                </TableCell>
                                                <TableCell>
                                                    {
                                                        listaPrecoItemDerivacaoProdutoQuantidade
                                                    }
                                                </TableCell>
                                                <TableCell>
                                                    {quantidade *
                                                        listaPrecoItemDerivacaoProdutoQuantidade}
                                                </TableCell>
                                                <TableCell>{pedido}</TableCell>
                                                <TableCell>
                                                    <OutputDate
                                                        value={dataPedido}
                                                    />
                                                </TableCell>
                                            </Hidden>
                                            <Hidden mdUp>
                                                <TableCell>
                                                    <div>
                                                        {listaPrecoItemNomeKit ||
                                                            nomeItem}
                                                    </div>
                                                    {dataRetirada && (
                                                        <Typography variant="caption">
                                                            RETIRADO:{' '}
                                                            <OutputDate
                                                                value={
                                                                    dataRetirada
                                                                }
                                                            />
                                                            <br />
                                                            POR:{' '}
                                                            {retiradoPor(
                                                                produtos,
                                                                pedido,
                                                            )}
                                                        </Typography>
                                                    )}
                                                </TableCell>
                                                <TableCell>
                                                    {quantidade *
                                                        listaPrecoItemDerivacaoProdutoQuantidade}
                                                </TableCell>
                                            </Hidden>
                                        </TableRow>
                                    ),
                                )}
                                <TableRow>
                                    <Hidden smDown>
                                        <TableCell colSpan="7">
                                            TOTAL À RETIRAR
                                        </TableCell>
                                    </Hidden>
                                    <Hidden mdUp>
                                        <TableCell colSpan="2">
                                            TOTAL À RETIRAR
                                        </TableCell>
                                    </Hidden>
                                    <TableCell
                                        style={{
                                            fontSize: '1.5em',
                                            fontWeight: 800,
                                        }}
                                    >
                                        {total}
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </>
            )}
        </>
    );
};

Selos.defaultProps = {
    value: [],
    onSelecionar: console.warn,
};

export default Selos;
